<div class="overlay">
    <app-header></app-header>
    <app-selected-client></app-selected-client>
</div>

<div class="card-body p-0">
    
    <!-- <img *ngIf="overlayNL" src="../../../assets/Logos/NLOverlay.png" alt="Background image NL">
    <img *ngIf="overlayFR" src="../../../assets/Logos/FROverlay.png" alt="Background image FR"> -->

    <div class="center-align">
        <div class="display-45">

            
                <div *ngIf="checkForHeader" class="header-blue">
                    <img  class="mr-4" style="width: 35px;height: 38px;" src="../../../assets/Logos/user.png" />
                    <div *ngIf="!checkforPass" style="padding-left: 30px;">
                        
                    {{'LOGIN_OD0004' | translate}}
                </div>
                <div *ngIf="checkforPass" style="padding-left: 30px;">
                    {{'ForgotPasswordLink_001'|translate}}
                </div>
                    <div class="language-change" id="languageDropdown" (click)="changeLanguage()">
                        {{ defaultLanguage === 'NL'? 'FR': 'NL' }}
                      </div>
                </div>
           
           <div *ngIf ="!checkforPass; else forgotpass">
            <div> 
                <app-authentication (displayHeader)="onDisplayHeader($event)" (displayForgotPass)="OnDisplayForgotPassword($event)" (userName)="getUsername($event)" [displayLoginscreen]="false" ></app-authentication> 
            </div>
        </div> 
            
        <ng-template #forgotpass>
             <app-forgot-password [username]="loginuser"> </app-forgot-password>
          </ng-template> 
    </div>  
</div>
</div> 

<ng-http-loader [entryComponent]="customSpinnerComponent"></ng-http-loader>
